import React, { useEffect, useState } from "react";
import { getSessions } from "../../services/sessionService";
import Loader from "../../components/Loader";

function Sessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSessions()
      .then(data => setSessions(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <div>
      <h2>Sessions</h2>
      <ul>
        {sessions.map(s => (
          <li key={s.id}>{s.user} - {s.duration} mins</li>
        ))}
      </ul>
    </div>
  );
}

export default Sessions;
